const navigate = (path) => {
	globalThis.location.href = path;
};

export default navigate;
